module.exports = __webpack_public_path__ + "img/abroad_logo_en.png.42a1f947.png";